import React from 'react';
import styled, { css } from 'styled-components';

import { colors } from 'global/colors';
import { Link as BaseLink, A as BaseA } from 'user/components';
import { Images } from 'util/images';

export const HeaderWrapper = styled.div`
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100px;
  transition: all 0.25s ease-in-out;
  z-index: 4;

  @media (max-width: 1024px) {
    ${(props) =>
      props.isOpened &&
      css`
        background: ${colors.darkBlue};
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
        height: 60px;
      `}
  }

  ${(props) =>
    props.isScrolled &&
    css`
      background: ${colors.darkBlue};
      height: 60px;
    `};
`;

export const HeaderContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 10%;

  @media (max-width: 1411px) {
    padding: 0 20px;
  }
`;

export const NavigationContainer = styled.div`
  color: ${colors.white};
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  display: flex;
  width: 100%;
  align-items: center;
  transition: all 0.25s ease-in-out;

  @media (max-width: 1024px) {
    flex-direction: column-reverse;
    padding: 10px 15px;
    align-items: flex-start;
    position: absolute;
    background: ${colors.white};
    top: 0;
    left: 0;
    right: 0;
    transform: translate(0, -100%);
    width: 100%;
    box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.5);

    ${(props) =>
      props.isOpened &&
      css`
        top: 60px;
        transform: translate(0, 0);
      `}
  }
`;

export const Link = styled(BaseLink)`
  margin-left: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: ${colors.white};

  :hover {
    color: ${colors.green};
  }

  :first-child {
    margin-left: 0;
  }

  @media (max-width: 1024px) {
    color: ${colors.darkGray2};
    margin-left: 0;
    margin-bottom: 5px;
  }
`;

export const Logo = styled.div`
  background: url(${Images.logo});
  background-size: contain;
  background-repeat: no-repeat;
  flex: 1 1 250px;
  width: 250px;
  height: 55px;
  transition: all 0.25s ease-in-out;

  ${(props) =>
    (props.isScrolled || props.isOpened) &&
    css`
      height: 45px;
    `}
`;

export const MenuIcon = styled.div`
  display: none;
  cursor: pointer;
  color: ${colors.white};
  :after {
    content: '\f0c9';
    font-family: FontAwesome;
    font-size: 32px;
  }

  @media (max-width: 1024px) {
    display: block;
  }
`;

const ExperienceRing = styled.svg`
  transform: rotate(-90deg);
  position: absolute;
`;

const calculateDashOffset = (radius, experience) => {
  const circumference = 2 * Math.PI * radius;
  const progress = experience / 100;
  return circumference * (1 - progress);
};

const FilledRing = styled.circle`
  stroke-dasharray: ${(props) => 2 * Math.PI * props.r};
  stroke-dashoffset: ${(props) => props.dashOffset};
  animation: progress 1s ease;
  animation-fill-mode: forwards;

  @keyframes progress {
    from {
      stroke-dashoffset: ${(props) => 2 * Math.PI * props.r};
    }
    to {
      stroke-dashoffset: ${(props) => props.dashOffset};
    }
  }
`;

export const ProfileExperience = ({ experience, children, size = 70 }) => (
  <ExperienceRing width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
    <circle cx={size / 2} cy={size / 2} r={(size - 10) / 2} fill="none" stroke={colors.lightGray2} strokeWidth="6" />
    <FilledRing
      dashOffset={calculateDashOffset((size - 10) / 2, experience)}
      cx={size / 2}
      cy={size / 2}
      r={(size - 10) / 2}
      fill="none"
      stroke={colors.green}
      strokeWidth="6"
    />
    {children}
  </ExperienceRing>
);

export const ProfileAvatarContainer = styled.div`
  position: relative;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(1);
  transition: all 0.25s ease-in-out;
  cursor: pointer;

  @media (max-width: 1024px) {
    transform: scale(0.8);
    width: 55px;
    height: 55px;
  }

  @media (min-width: 1025px) {
    ${(props) =>
      props.isScrolled &&
      css`
        transform: scale(0.75);
      `}
  }
`;

export const ProfileExperienceText = styled.span`
  position: absolute;
  color: ${colors.white};
  font-weight: bold;
  user-select: none;
`;

export const ProfileAvatar = styled.div`
  position: absolute;
  flex-shrink: 0;
  border-radius: 50%;
  width: 58px;
  height: 58px;
  background-image: url(${(props) => props.image || ''});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
`;

export const LinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
`;

export const A = styled(BaseA)`
  margin-left: 15px;
  @media (max-width: 1024px) {
    margin-left: 0;
    margin-bottom: 5px;
  }

  ${(props) =>
    props.textLink &&
    css`
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-left: 20px;

      :hover {
        color: ${colors.green};
      }

      @media (max-width: 1024px) {
        color: ${colors.darkGray2};
      }
    `}
`;
